/**
 * @name API Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

// #region common

import { API } from '../config';

const base = `${API.BASE_DEV_HOST}/api/firms`;

export const all = `${base}`;
export const userManagementFirmList = (userId: string, isFromUserPage = true) =>
  `${base}?user_id=${userId}&is_from_user_page=${isFromUserPage}`;
export const selectedUserPermissions = (userId: string) => `${base}?user_id=${userId}`;
export const create = `${base}/new`;
// Get a firm by its id
export const firmById = (firmId: number) => `${base}/${firmId}`;
// Get the list of companies that belong to a firm
export const getCompanyListByFirmId = (firmId: string) => `${base}/${firmId}/companies`;
// Get the summary firm table
export const getFundByFirmId = (firmId: string) => `${base}/${firmId}/summary`;
// Get the list of funds that will be shown in the navigation
export const getFundListByFirmId = (firmId: number) => `${base}/${firmId}/funds`;
// Create a new company for a specific firm
export const createFirmCompany = `${base}/companies/new`;
// Create a new company for a specific firm
export const getCompaniesFromPreviousMD = (firmId: string, date: string) => `${base}/${firmId}/companies-list/${date}`;
// Add user to firm
export const addUserToFirm = (firmId: number) => `${base}/${firmId}/users`;
// Remove user from firm
export const removeUserFromFirm = (firmId: number, userId: number) => `${base}/${firmId}/users/${userId}`;
// Get the company extended info (data from the vw_firm_companies SQL view)
export const getFirmCompanyExtendedInfo = (firmId: number, companyId: number) =>
  `${base}/${firmId}/company/${companyId}`;
// Create or Update Comp Group
export const createOrUpdateCompGroups = (firmId: number) =>
  `${API.BASE_DEV_HOST}/api/valuation/comp-group/firm/${firmId}`;
// See pending decisions for this firm
export const getPendingDecisions = (firmId: string) => `${API.BASE_DEV_HOST}/api/pending-decisions/${firmId}`;
// Get tasks progress for a firm
export const getTasksProgress = (firmId: string) => `${base}/${firmId}/requests-progress`;
// Get base set of questions and documents for a firm
export const getFirmSetOfQuestionsAndDocuments = (firmId: string) =>
  `${base}/${firmId}/questions-and-requested-documents`;
// Create required tasks for selected companies of a firm
export const createRequestedTasks = `${base}/create-requests`;
// Get progress detail for a task
export const getTaskProgressDetail = (taskId: string) => `${API.BASE_DEV_HOST}/api/tasks/${taskId}/progress-detail`;
// Change the user firm role
export const changeUserFirmRole = (firmId: number, userId: number) => `${base}/${firmId}/users/${userId}/roles`;
// Create a new requested question for a firm
export const createRequestedQuestion = `${base}/create-firm-question`;
// Delete a requested question for a firm
export const deleteRequestedQuestion = (questionId: number) => `${base}/question/${questionId}`;
// Update a requested question for a firm
export const updateRequestedQuestion = (questionId: number) => `${base}/question/${questionId}`;
// Create a new requested document for a firm
export const createFirmRequestedDocument = `${base}/create-firm-requested-document`;
// Delete a requested document for a firm
export const deleteFirmRequestedDocument = (requestedDocumentId: number) =>
  `${base}/firm-requested-document/${requestedDocumentId}`;
// Update a requested document for a firm
export const updateFirmRequestedDocument = (requestedDocumentId: number) =>
  `${base}/firm-requested-document/${requestedDocumentId}`;
export const hasFirmSummary = (firmId?: number) => `${base}/${firmId}/has-summary`;

// Get the firm-level schedule of investments. When `fundId` is supplied the
// response mirrors the fund-level endpoint; otherwise it spans every fund in
// the firm.
export const getFirmInvestments = (
  firmId: number,
  fundId: number | null | undefined,
  date: string | null | undefined,
  checkForExport: boolean
) => {
  const params = new URLSearchParams();
  if (fundId) {
    params.append('fund_id', String(fundId));
  }
  if (date) {
    params.append('date', date);
  }
  params.append('export', checkForExport.toString());
  return `${base}/${firmId}/investments?${params.toString()}`;
};

export const getFirmAssetSignedUrl = (firmId: number, fileType: string) =>
  `${base}/${firmId}/asset-signed-url/${fileType}`;
